import { string, object } from 'yup';

const assetCreationSchema = object().shape({
  barcode: string().required('Please enter barcode'),
  vehicleType: string().required('Please choose vehicle type'),
  assetName: string().nullable(),
  assetIdentificationNumber: string().nullable(),
  licensePlate: string().nullable(),
  vinNumber: string().nullable()
});

export default assetCreationSchema;
